import ApiService from "@/common/api/api.service";

let endpoint = "ProjetoGestao";

const Resultados = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    salvar(rubrica, form) {
        if(form.id)
            return ApiService.put(`${endpoint}/${rubrica}`, form)
        else
            return ApiService.post(`${endpoint}/${rubrica}`, form)
            
    },

    atualizar(rubrica, form) {
        return ApiService.put(`${endpoint}/${rubrica}`, form)
    },

    listar(rubrica,id, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`${endpoint}/${rubrica}?ProjetoGestaoId=${id}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    buscar(rubrica, id) {
        return ApiService.get(`${endpoint}/${rubrica}?id=${id}`);
    },

    deletar(rubrica, id) {
        let form = {
            id: id
        }
        return ApiService.delete(`${endpoint}/${rubrica}`, form);
    },

    downloadArquivo(rubrica, arquivoId) {
        return ApiService.downloadFile(`${endpoint}/${rubrica}/download-arquivo?id=${arquivoId}`)
    },
}

export default Resultados;
